<template>
  <Tags
    :variant="maxTablet ? undefined : 'property'"
    :title="$t('components.task_details.tags.title')"
    :description="$t('components.task_details.tags.description')"
    :initialState="task.tags"
    :readonly="readonly"
    :buildingIds="[task.tenant.id]"
    @update="updateTags"
  />
</template>
<script setup>
import { Tags } from "@/SharedComponents/Parts";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();

const emit = defineEmits(["update"]);

const props = defineProps({
  task: { type: Object, required: true },
  readonly: { type: Boolean, required: false },
});

function updateTags(data) {
  if (props.readonly) {
    return;
  }
  emit("update", { tag_ids: data.map((tag) => tag.id) });
}
</script>
